// src/utils/qualFmt.js
import {
    describeJtbdImportance,
    describeJtbdSatisfaction,
    describeReasonNotChosenImportance,
    describeInsightSentimentIntensity,
    describePositiveImportance,
    describeDrawbackImportance,
    describeSatisfactionLevel, // 0–10 satisfaction rubric
  } from './qualitative';
  
  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };
  
  /** All metrics are 0–10. Clamp only. */
  export function normalizeScale(value) {
    const n = toNum(value);
    if (n == null) return { n: null, v10: null };
    const v10 = Math.max(0, Math.min(10, n));
    return { n, v10 };
  }
  
  export function fmt(value, describeFn, { digits = 1 } = {}) {
    const { v10 } = normalizeScale(value);
    if (v10 == null) return { text: '—', v10: 0, label: '' };
    const label = describeFn(v10);
    const numTxt = v10.toFixed(digits);
    return { text: `${numTxt} · ${label}`, v10, label };
  }
  
  /* Convenience wrappers by metric (all 0–10) */
  export const F = {
    jtbdImportance: (v, opts) => fmt(v, describeJtbdImportance, opts),
    jtbdSatisfaction: (v, opts) => fmt(v, describeJtbdSatisfaction, opts),
    reasonNotChosenImportance: (v, opts) => fmt(v, describeReasonNotChosenImportance, opts),
    insightIntensity: (v, opts) => fmt(v, describeInsightSentimentIntensity, opts),
    positiveImportance: (v, opts) => fmt(v, describePositiveImportance, opts),
    drawbackImportance: (v, opts) => fmt(v, describeDrawbackImportance, opts),
    productSatisfaction: (v, opts) => fmt(v, describeSatisfactionLevel, opts),
  };
  